import { IconProps, iconA11yProps } from '../types';

export const Presentation = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <rect x="5" y="6" width="14" height="12" rx="2" />
        <path d="M2 8L2 16" />
        <path d="M22 8L22 16" />
    </svg>
);
